import React, { Component } from 'react';
import styled from 'styled-components';
import media from '../../../../theme/media';
import { Icon } from '../../../../theme/assets';
import { Caption } from '../../../../theme/typography';


const ContainerRight = styled.div`
  width: 50%;
  display: inline-block;
  vertical-align: middle;
  ${media.phone`
    width: 100%;
    max-width: 400px;
    margin: 0 auto 4rem auto;
    display: block;
  `}
`;

const ContainerLeft = styled.div`
  width: 50%;
  display: inline-block;
  vertical-align: middle;
  ${media.phone`
    width: 100%;
    max-width: 400px;
    margin: 0 auto 4rem auto;
    display: block;
  `}
`;

const Panel = styled.div`
  background: #FFFFFF;
  padding: 48px 32px 32px 32px;
  height: 614px;
`;

const PanelHeader = styled.div`
  height: 32px;
  margin-bottom: 1rem;
  span {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    color: #1E1F21;
  }
  svg {
    float: right;
  }
`;

const Color = styled.button`
  border: 1px solid rgba(0,0,0,.2);
  border-radius: 100%;
  display: inline-block;
  background: white;
  width: 32px;
  height: 32px;
  margin: 8px;
  ${media.tablet`
    width: 24px;
    height: 24px;
  `}
  ${media.phone`
    width: 32px;
    height: 32px;
  `}
  ${media.tiny`
    width: 24px;
    height: 24px;
  `}
  
`;

const PanelStat = styled.div`
  text-align: left;
  margin-bottom: 16px;
  span {
    display: inline-block;
    line-height: 27px;
    font-size: 16px;
  }
  div:nth-child(1) {
    width: 50%;
    display: inline-block;
  }
  div:nth-child(2) {
    width: 50%;
    display: inline-block;
    text-align: right;
  }
`;

const PaletteContainer = styled.div`
  width: fit-content;
  width: -moz-fit-content;
  float: right;
  ${media.phone`
    float: none;
  `}
  &.color-yellow-10 button.color-yellow-10,
  &.color-orange-30 button.color-orange-30,
  &.color-red-30 button.color-red-30,
  &.color-pink-30 button.color-pink-30,
  &.color-purple-30 button.color-purple-30,
  &.color-violet-30 button.color-violet-30,
  &.color-blue-20 button.color-blue-20,
  &.color-green-40 button.color-green-40,
  &.color-yellow-20 button.color-yellow-20,
  &.color-orange-20 button.color-orange-20,
  &.color-red-40 button.color-red-40,
  &.color-pink-40 button.color-pink-40,
  &.color-purple-40 button.color-purple-40,
  &.color-violet-40 button.color-violet-40,
  &.color-blue-40 button.color-blue-40,
  &.color-green-50 button.color-green-50,
  &.color-yellow-30 button.color-yellow-30,
  &.color-orange-50 button.color-orange-50,
  &.color-red-50 button.color-red-50,
  &.color-pink-50 button.color-pink-50,
  &.color-purple-50 button.color-purple-50,
  &.color-violet-50 button.color-violet-50,
  &.color-blue-50 button.color-blue-50,
  &.color-green-60 button.color-green-60,
  &.color-yellow-40 button.color-yellow-40,
  &.color-orange-60 button.color-orange-60,
  &.color-red-60 button.color-red-60,
  &.color-pink-60 button.color-pink-60,
  &.color-purple-60 button.color-purple-60,
  &.color-violet-60 button.color-violet-60,
  &.color-blue-60 button.color-blue-60,
  &.color-green-70 button.color-green-70,
  &.color-yellow-50 button.color-yellow-50,
  &.color-orange-70 button.color-orange-70,
  &.color-red-70 button.color-red-70,
  &.color-pink-70 button.color-pink-70,
  &.color-purple-70 button.color-purple-70,
  &.color-violet-70 button.color-violet-70,
  &.color-blue-80 button.color-blue-80,
  &.color-green-80 button.color-green-80,
  &.color-black button.color-black,
  &.color-off-black button.color-off-black,
  &.color-gray-90 button.color-gray-90,
  &.color-gray-80 button.color-gray-80,
  &.color-gray-70 button.color-gray-70,
  &.color-gray-60 button.color-gray-60,
  &.color-gray-50 button.color-gray-50,
  &.color-gray-40 button.color-gray-40,
  &.color-gray-30 button.color-gray-30,
  &.color-gray-20 button.color-gray-20,
  &.color-gray-10 button.color-gray-10,
  &.color-white button.color-white {
      box-shadow: 0 0 0 6px white, 0 0 0 8px #F50900;
  }
  
  
`;

const PanelValue = styled.span`
  font-weight: 600;
  color: #1E1F21;
  &.Pass {
    color: #2C9500;
  }
  
  &.Fail {
    color: #FF0900;
  }
`;

const PanelTab = styled.div`
`;
const PanelSwatches = styled.div`
  margin-top: 2rem;
`;
const PanelSwatch = styled.div`
  width: calc(50% - 4px);
  display: inline-block;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, .2);
  padding: 40px 0;
  &:nth-child(2) {
    float: right;
  }
  &.white {
    color: white;
  }
  &.black {
    color: black;
  }
  &.black-background {
    background-color: black;
  }
`;
const SpanNormal = styled.span`
  font-size: 16px;
  font-weight: normal;
  display: block;
  margin-bottom: 4px;
`;
const SpanBold = styled.span`
  font-size: 18px;
  font-weight: bold;
  display: block;
  margin-bottom: 4px;
`;
const SpanLarge = styled.span`
  font-size: 24px;
  font-weight: normal;
  display: block;
  margin-bottom: 4px;
`;

const PanelTabs = styled.div`
  button:nth-child(1) {
    position: relative;
    &::before {
      position: absolute;
      bottom: -12px;
      left: 0;
      width: 100%;
      height: 2px;
      background: #000000;
      content: '';
      transform: translate3d(100%,0,0);
      z-index: 3;
    }
  }
  button:nth-child(2) {
    color: #1E1F21;
    font-weight: 600;
  }
  &.value button:nth-child(1) {
    color: #1E1F21;
    font-weight: 600;
  }
  &.value button:nth-child(2),
  &.value button:nth-child(3) {
    font-weight: 400;
    color: #637282;
  }
  &.white button:nth-child(2) {
    color: #1E1F21;
    font-weight: 600;
  }
  &.white button:nth-child(1),
  &.white button:nth-child(3) {
    font-weight: 400;
    color: #637282;
  }
  &.black button:nth-child(3) {
    color: #1E1F21;
    font-weight: 600;
  }
  &.black button:nth-child(1),
  &.black button:nth-child(2) {
    font-weight: 400;
    color: #637282;
  }
  &.value button:nth-child(1) {
    &::before {
      transition: transform .3s;
      transform: translate3d(0,0,0);
    }
  }
  &.white button:nth-child(1) {
    &::before {
      transition: transform .3s;
      transform: translate3d(100%,0,0);
    }
  }
  &.black button:nth-child(1) {
    &::before {
      transition: transform .3s;
      transform: translate3d(200%,0,0);
    }
  }
  border-bottom: 1px solid #E6E8EB;
  line-height: 41px;
  margin-bottom: 2rem;
`;

const PanelTabButton = styled.button`
  font-size: 14px;
  font-weight: 400;
  color: #637282;
  background: white;
  width: 64px;
  text-align: center;
`;

class Contrast extends Component {
  constructor() {
    super();
    this.state = {
       
      panel1: false,
      panel2: true,
      panel3: false,
      panel1Button: '',
      
      name: 'Gray 70',
      color: '#5E5E72',
      scss: 'color-gray-70',
      rgba: 'rgba(94, 94, 114, 1)',
      
      whiteRatio: '6.33 : 1',
      whiteNormalAA: 'Pass',
      whiteNormalAAA: 'Fail',
      whiteLargeAA: 'Pass',
      whiteLargeAAA: 'Pass',
      
      blackRatio: '3.32 : 1',
      blackNormalAA: 'Fail',
      blackNormalAAA: 'Fail',
      blackLargeAA: 'Pass',
      blackLargeAAA: 'Fail'
    }
  }
  onColor1 = e => {
    if (e.target.value === '#FFFF98') {
      this.setState({
        name: 'Yellow 10',
        color: '#FFFF98',
        scss: 'color-yellow-10',
        rgba: 'rgba(255, 255, 152, 1)',
        
        whiteRatio: '1.05 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '20 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FFA266') {
      this.setState({
        name: 'Orange 30',
        color: '#FFA266',
        scss: 'color-orange-30',
        rgba: 'rgba(255, 162, 102, 1)',
        
        whiteRatio: '1.98 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '10.61 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FF848B') {
      this.setState({
        name: 'Red 30',
        color: '#FF848B',
        scss: 'color-red-30',
        rgba: 'rgba(255, 132, 139, 1)',
        
        whiteRatio: '2.35 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '8.93 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FF6BBA') {
      this.setState({
        name: 'Pink 30',
        color: '#FF6BBA',
        scss: 'color-pink-30',
        rgba: 'rgba(255, 107, 186, 1)',
        
        whiteRatio: '2.61 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '8.06 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#F770FF') {
      this.setState({
        name: 'Purple 30',
        color: '#F770FF',
        scss: 'color-purple-30',
        rgba: 'rgba(247, 112, 255, 1)',
        
        whiteRatio: '2.4 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '8.72 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#C689FF') {
      this.setState({
        name: 'Violet 30',
        color: '#C689FF',
        scss: 'color-violet-30',
        rgba: 'rgba(198, 137, 255, 1)',
        
        whiteRatio: '2.49 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '8.42 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#00DDFF') {
      this.setState({
        name: 'Blue 20',
        color: '#00DDFF',
        scss: 'color-blue-20',
        rgba: 'rgba(0, 221, 255, 1)',
        
        whiteRatio: '1.64 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '12.79 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#54FFBD') {
      this.setState({
        name: 'Green 40',
        color: '#54FFBD',
        scss: 'color-green-40',
        rgba: 'rgba(84, 255, 189, 1)',
        
        whiteRatio: '1.28 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '16.42 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FFEA80') {
      this.setState({
        name: 'Yellow 20',
        color: '#FFEA80',
        scss: 'color-yellow-20',
        rgba: 'rgba(255, 234, 128, 1)',
        
        whiteRatio: '1.21 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '17.33 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FF8A50') {
      this.setState({
        name: 'Orange 40',
        color: '#FF8A50',
        scss: 'color-orange-40',
        rgba: 'rgba(255, 138, 80, 1)',
        
        whiteRatio: '2.33 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '9:1 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FF6A75') {
      this.setState({
        name: 'Red 40',
        color: '#FF6A75',
        scss: 'color-red-40',
        rgba: 'rgba(255, 106, 117, 1)',
        
        whiteRatio: '2.77 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '7.57 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FF4AA2') {
      this.setState({
        name: 'Pink 40',
        color: '#FF4AA2',
        scss: 'color-pink-40',
        rgba: 'rgba(255, 74, 162, 1)',
        
        whiteRatio: '3.11 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '6.75 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#D74CF0') {
      this.setState({
        name: 'Purple 40',
        color: '#D74CF0',
        scss: 'color-purple-40',
        rgba: 'rgba(215, 76, 240, 1)',
        
        whiteRatio: '3.4 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '6.18 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#AB71FF') {
      this.setState({
        name: 'Violet 40',
        color: '#AB71FF',
        scss: 'color-violet-40',
        rgba: 'rgba(171, 113, 255, 1)',
        
        whiteRatio: '3.21 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '6.54 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#0090ED') {
      this.setState({
        name: 'Blue 40',
        color: '#0090ED',
        scss: 'color-blue-40',
        rgba: 'rgba(0, 144, 237, 1)',
        
        whiteRatio: '3.38 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '6.21 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#3FE1B0') {
      this.setState({
        name: 'Green 50',
        color: '#3FE1B0',
        scss: 'color-green-50',
        rgba: 'rgba(63, 225, 176, 1)',
        
        whiteRatio: '1.67 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '12.61 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FFD567') {
      this.setState({
        name: 'Yellow 30',
        color: '#FFD567',
        scss: 'color-yellow-30',
        rgba: 'rgba(255, 213, 103, 1)',
        
        whiteRatio: '1.41 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '14.97 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FF7139') {
      this.setState({
        name: 'Orange 50',
        color: '#FF7139',
        scss: 'color-orange-50',
        rgba: 'rgba(255, 113, 57, 1)',
        
        whiteRatio: '2.74 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '7.61 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FF4F5E') {
      this.setState({
        name: 'Red 50',
        color: '#FF4F5E',
        scss: 'color-red-50',
        rgba: 'rgba(255, 79, 94, 1)',
        
        whiteRatio: '3.21 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '6.54 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FF298A') {
      this.setState({
        name: 'Pink 50',
        color: '#FF298A',
        scss: 'color-pink-50',
        rgba: 'rgba(255, 41, 138, 1)',
        
        whiteRatio: '3.54 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '5.94 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#B833E1') {
      this.setState({
        name: 'Purple 50',
        color: '#B833E1',
        scss: 'color-purple-50',
        rgba: 'rgba(184, 51, 225, 1)',
        
        whiteRatio: '4.57 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '4.61 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#9059FF') {
      this.setState({
        name: 'Violet 50',
        color: '#9059FF',
        scss: 'color-violet-50',
        rgba: 'rgba(144, 89, 225, 1)',
        
        whiteRatio: '4.15 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '5.06 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#0077DD') {
      this.setState({
        name: 'Blue 50',
        color: '#0077DD',
        scss: 'color-blue-50',
        rgba: 'rgba(0, 96, 223, 1)',
        
        whiteRatio: '5.62 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '3.74 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#2AC3A2') {
      this.setState({
        name: 'Green 60',
        color: '#2AC3A2',
        scss: 'color-green-60',
        rgba: 'rgba(42, 195, 162, 1)',
        
        whiteRatio: '2.23 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '9.43 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FFBD4F') {
      this.setState({
        name: 'Yellow 40',
        color: '#FFBD4F',
        scss: 'color-yellow-40',
        rgba: 'rgba(255, 189, 79, 1)',
        
        whiteRatio: '1.66 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '12.64 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#E25920') {
      this.setState({
        name: 'Orange 60',
        color: '#E25920',
        scss: 'color-orange-60',
        rgba: 'rgba(226, 89, 32, 1)',
        
        whiteRatio: '3.69 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '5.68 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#E22850') {
      this.setState({
        name: 'Red 60',
        color: '#E22850',
        scss: 'color-red-60',
        rgba: 'rgba(226, 40, 80, 1)',
        
        whiteRatio: '4.51 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '4.65 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#E31587') {
      this.setState({
        name: 'Pink 60',
        color: '#E31587',
        scss: 'color-pink-60',
        rgba: 'rgba(227, 21, 135, 1)',
        
        whiteRatio: '4.45 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '4.72 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#952BB9') {
      this.setState({
        name: 'Purple 60',
        color: '#952BB9',
        scss: 'color-purple-60',
        rgba: 'rgba(149, 43, 185, 1)',
        
        whiteRatio: '6.32 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '3.32 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#7542E5') {
      this.setState({
        name: 'Violet 60',
        color: '#7542E5',
        scss: 'color-violet-60',
        rgba: 'rgba(117, 66, 229, 1)',
        
        whiteRatio: '5.73 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '3.67 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#0250BB') {
      this.setState({
        name: 'Blue 60',
        color: '#0250BB',
        scss: 'color-blue-60',
        rgba: 'rgba(2, 80, 187, 1)',
        
        whiteRatio: '7.32 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Pass',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '2.87 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Fail',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#008787') {
      this.setState({
        name: 'Green 70',
        color: '#008787',
        scss: 'color-green-70',
        rgba: 'rgba(0, 135, 135, 1)',
        
        whiteRatio: '4.36 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '4.82 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FFA436') {
      this.setState({
        name: 'Yellow 50',
        color: '#FFA436',
        scss: 'color-yellow-50',
        rgba: 'rgba(255, 164, 54, 1)',
        
        whiteRatio: '1.98 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '10.62 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#CC3D00') {
      this.setState({
        name: 'Orange 70',
        color: '#CC3D00',
        scss: 'color-orange-70',
        rgba: 'rgba(204, 61, 0, 1)',
        
        whiteRatio: '4.96 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '4.23 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#C50042') {
      this.setState({
        name: 'Red 70',
        color: '#C50042',
        scss: 'color-red-70',
        rgba: 'rgba(197, 0, 66, 1)',
        
        whiteRatio: '6.08 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '3.45 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#C60084') {
      this.setState({
        name: 'Pink 70',
        color: '#C60084',
        scss: 'color-pink-70',
        rgba: 'rgba(198, 0, 132, 1)',
        
        whiteRatio: '5.62 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '3.73 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#722291') {
      this.setState({
        name: 'Purple 70',
        color: '#722291',
        scss: 'color-purple-70',
        rgba: 'rgba(114, 34, 145, 1)',
        
        whiteRatio: '8.92 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '2.35 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Fail',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#592ACB') {
      this.setState({
        name: 'Violet 70',
        color: '#592ACB',
        scss: 'color-violet-70',
        rgba: 'rgba(89, 42, 203, 1)',
        
        whiteRatio: '8.02 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Pass',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '2.62 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Fail',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#073072') {
      this.setState({
        name: 'Blue 80',
        color: '#073072',
        scss: 'color-blue-80',
        rgba: 'rgba(7, 48, 114, 1)',
        
        whiteRatio: '12.54 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Pass',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '1.67 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Fail',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#005E5E') {
      this.setState({
        name: 'Green 80',
        color: '#005E5E',
        scss: 'color-green-80',
        rgba: 'rgba(0, 94, 94, 1)',
        
        whiteRatio: '7.61 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Pass',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '2.76 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Fail',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#000000') {
      this.setState({
        name: 'Black',
        color: '#000000',
        scss: 'color-black',
        rgba: 'rgba(0, 0, 0, 1)',
        
        whiteRatio: '21 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Pass',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '1 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Fail',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#20123A') {
      this.setState({
        name: 'Off Black',
        color: '#20123A',
        scss: 'color-off-black',
        rgba: 'rgba(32, 18, 58, 1)',
        
        whiteRatio: '17.37 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Pass',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '1.21 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Fail',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#202340') {
      this.setState({
        name: 'Gray 90',
        color: '#202340',
        scss: 'color-gray-90',
        rgba: 'rgba(32, 35, 64, 1)',
        
        whiteRatio: '15.26 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Pass',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '1.38 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Fail',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#42425A') {
      this.setState({
        name: 'Gray 80',
        color: '#42425A',
        scss: 'color-gray-80',
        rgba: 'rgba(66, 66, 90, 1)',
        
        whiteRatio: '9.73 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Pass',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '2.16 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Fail',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#5E5E72') {
      this.setState({
        name: 'Gray 70',
        color: '#5E5E72',
        scss: 'color-gray-70',
        rgba: 'rgba(94, 94, 114, 1)',
        
        whiteRatio: '6.33 : 1',
        whiteNormalAA: 'Pass',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Pass',
        
        blackRatio: '3.32 : 1',
        blackNormalAA: 'Fail',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Fail'
      });
    } else if (e.target.value === '#7A7A8B') {
      this.setState({
        name: 'Gray 60',
        color: '#7A7A8B',
        scss: 'color-gray-60',
        rgba: 'rgba(122, 122, 139, 1)',
        
        whiteRatio: '4.21 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Pass',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '4.98 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Fail',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#9595A3') {
      this.setState({
        name: 'Gray 50',
        color: '#9595A3',
        scss: 'color-gray-50',
        rgba: 'rgba(149, 149, 163, 1)',
        
        whiteRatio: '2.96 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '7.11 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#B1B1BC') {
      this.setState({
        name: 'Gray 40',
        color: '#B1B1BC',
        scss: 'color-gray-40',
        rgba: 'rgba(177, 177, 188, 1)',
        
        whiteRatio: '2.12 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '9.88 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#CDCDD4') {
      this.setState({
        name: 'Gray 30',
        color: '#CDCDD4',
        scss: 'color-gray-30',
        rgba: 'rgba(205, 205, 212, 1)',
        
        whiteRatio: '1.58 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '13.28 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#EDEDF0') {
      this.setState({
        name: 'Gray 20',
        color: '#EDEDF0',
        scss: 'color-gray-20',
        rgba: 'rgba(237, 237, 240, 1)',
        
        whiteRatio: '1.17 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '17.97 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#F9F9FA') {
      this.setState({
        name: 'Gray 10',
        color: '#F9F9FA',
        scss: 'color-gray-10',
        rgba: 'rgba(249, 249, 250, 1)',
        
        whiteRatio: '1.05 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '19.96 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    } else if (e.target.value === '#FFFFFF') {
      this.setState({
        name: 'White',
        color: '#FFFFFF',
        scss: 'color-white',
        rgba: 'rgba(255, 255, 255, 1)',
        
        whiteRatio: '1 : 1',
        whiteNormalAA: 'Fail',
        whiteNormalAAA: 'Fail',
        whiteLargeAA: 'Fail',
        whiteLargeAAA: 'Fail',
        
        blackRatio: '21 : 1',
        blackNormalAA: 'Pass',
        blackNormalAAA: 'Pass',
        blackLargeAA: 'Pass',
        blackLargeAAA: 'Pass'
      });
    }
  }
  showPanel1 = e => {
      this.setState({
        panelButton: 'value',
        panel1: true,
        panel2: false,
        panel3: false
      });
  }
  showPanel2 = e => {
      this.setState({
        panelButton: 'white',
        panel1: false,
        panel2: true,
        panel3: false
      });
  }
  showPanel3 = e => {
      this.setState({
        panelButton: 'black',
        panel1: false,
        panel2: false,
        panel3: true
      });
  }
  render() {
    return (
      <div>
        <ContainerLeft>
          <Panel>
            
            <PanelTabs className={this.state.panelButton}>
                <PanelTabButton onClick={this.showPanel1.bind(this)}>Value</PanelTabButton>
                <PanelTabButton onClick={this.showPanel2.bind(this)}>White</PanelTabButton>
                <PanelTabButton onClick={this.showPanel3.bind(this)}>Black</PanelTabButton>
            </PanelTabs>
            
            {this.state.panel1 && 
              <PanelTab>
                <PanelStat>
                  <div>
                    <span>Name</span>
                  </div>
                  <div>
                    <PanelValue>{this.state.name}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>SCSS Variable</span>
                  </div>
                  <div>
                    <PanelValue>${this.state.scss}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>Hex Code</span>
                  </div>
                  <div>
                    <PanelValue>{this.state.color}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>RGBA</span>
                  </div>
                  <div>
                    <PanelValue>{this.state.rgba}</PanelValue>
                  </div>
                </PanelStat>
              </PanelTab>
            }
            
            {this.state.panel2 && 
              <PanelTab>
                <PanelStat>
                  <div>
                    <span>Ratio</span>
                  </div>
                  <div>
                    <PanelValue className={this.state.whiteRatio}>{this.state.whiteRatio}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>Normal AA</span>
                  </div>
                  <div>
                    <PanelValue className={this.state.whiteNormalAA}>{this.state.whiteNormalAA}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>Normal AAA</span>
                  </div>
                  <div>
                    <PanelValue className={this.state.whiteNormalAAA}>{this.state.whiteNormalAAA}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>Large AA</span>
                  </div>
                  <div>
                    <PanelValue className={this.state.whiteLargeAA}>{this.state.whiteLargeAA}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>Large AAA</span>
                  </div>
                  <div>
                    <PanelValue className={this.state.whiteLargeAAA}>{this.state.whiteLargeAAA}</PanelValue>
                  </div>
                </PanelStat>
                
                <PanelSwatches>
                    <PanelSwatch className="white" style={{backgroundColor: this.state.color}}>
                        <SpanNormal>Normal</SpanNormal>
                        <SpanBold>Large Bold</SpanBold>
                        <SpanLarge>Large</SpanLarge>
                    </PanelSwatch>
                    <PanelSwatch>
                        <SpanNormal style={{color: this.state.color}}>Normal</SpanNormal>
                        <SpanBold style={{color: this.state.color}}>Large Bold</SpanBold>
                        <SpanLarge style={{color: this.state.color}}>Large</SpanLarge>
                    </PanelSwatch>
                </PanelSwatches>
              </PanelTab>
            }
            {this.state.panel3 && 
              <PanelTab>
                <PanelStat>
                  <div>
                    <span>Ratio</span>
                  </div>
                  <div>
                    <PanelValue className={this.state.blackRatio}>{this.state.blackRatio}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>Normal AA</span>
                  </div>
                  <div>
                    <PanelValue className={this.state.blackNormalAA}>{this.state.blackNormalAA}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>Normal AAA</span>
                  </div>
                  <div>
                    <PanelValue className={this.state.blackNormalAAA}>{this.state.blackNormalAAA}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>Large AA</span>
                  </div>
                  <div>
                    <PanelValue className={this.state.blackLargeAA}>{this.state.blackLargeAA}</PanelValue>
                  </div>
                </PanelStat>
                <PanelStat>
                  <div>
                    <span>Large AAA</span>
                  </div>
                  <div>
                    <PanelValue className={this.state.blackLargeAAA}>{this.state.blackLargeAAA}</PanelValue>
                  </div>
                </PanelStat>
                
                <PanelSwatches>
                    <PanelSwatch className="black" style={{backgroundColor: this.state.color}}>
                        <SpanNormal>Normal</SpanNormal>
                        <SpanBold>Large Bold</SpanBold>
                        <SpanLarge>Large</SpanLarge>
                    </PanelSwatch>
                    <PanelSwatch className="black-background">
                        <SpanNormal style={{color: this.state.color}}>Normal</SpanNormal>
                        <SpanBold style={{color: this.state.color}}>Large Bold</SpanBold>
                        <SpanLarge style={{color: this.state.color}}>Large</SpanLarge>
                    </PanelSwatch>
                </PanelSwatches>
              </PanelTab>
            }
          </Panel>
        </ContainerLeft>
        <ContainerRight>
          <PaletteContainer className={this.state.scss}>
            <div>
              <Color className="color-yellow-10" style={{background: '#FFFF98'}} value={"#FFFF98"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-orange-30" style={{background: '#FFA266'}} value={"#FFA266"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-red-30" style={{background: '#FF848B'}} value={"#FF848B"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-pink-30" style={{background: '#FF6BBA'}} value={"#FF6BBA"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-purple-30" style={{background: '#F770FF'}} value={"#F770FF"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-violet-30" style={{background: '#C689FF'}} value={"#C689FF"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-blue-20" style={{background: '#00DDFF'}} value={"#00DDFF"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-green-40" style={{background: '#54FFBD'}} value={"#54FFBD"} onClick={e => this.onColor1(e, "value")}/>
            </div>
            <div>
              <Color className="color-yellow-20" style={{background: '#FFEA80'}} value={"#FFEA80"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-orange-20" style={{background: '#FF8A50'}} value={"#FF8A50"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-red-40" style={{background: '#FF6A75'}} value={"#FF6A75"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-pink-40" style={{background: '#FF4AA2'}} value={"#FF4AA2"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-purple-40" style={{background: '#D74CF0'}} value={"#D74CF0"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-violet-40" style={{background: '#AB71FF'}} value={"#AB71FF"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-blue-40" style={{background: '#0090ED'}} value={"#0090ED"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-green-50" style={{background: '#3FE1B0'}} value={"#3FE1B0"} onClick={e => this.onColor1(e, "value")}/>
            </div>
            <div>
              <Color className="color-yellow-30" style={{background: '#FFD567'}} value={"#FFD567"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-orange-50" style={{background: '#FF7139'}} value={"#FF7139"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-red-50" style={{background: '#FF4F5E'}} value={"#FF4F5E"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-pink-50" style={{background: '#FF298A'}} value={"#FF298A"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-purple-50" style={{background: '#B833E1'}} value={"#B833E1"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-violet-50" style={{background: '#9059FF'}} value={"#9059FF"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-blue-50" style={{background: '#0077DD'}} value={"#0077DD"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-green-60" style={{background: '#2AC3A2'}} value={"#2AC3A2"} onClick={e => this.onColor1(e, "value")}/>
            </div>
            <div>
              <Color className="color-yellow-40" style={{background: '#FFBD4F'}} value={"#FFBD4F"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-orange-60" style={{background: '#E25920'}} value={"#E25920"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-red-60" style={{background: '#E22850'}} value={"#E22850"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-pink-60" style={{background: '#E31587'}} value={"#E31587"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-purple-60" style={{background: '#952BB9'}} value={"#952BB9"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-violet-60" style={{background: '#7542E5'}} value={"#7542E5"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-blue-60" style={{background: '#0250BB'}} value={"#0250BB"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-green-70" style={{background: '#008787'}} value={"#008787"} onClick={e => this.onColor1(e, "value")}/>
            </div>
            <div>
              <Color className="color-yellow-50" style={{background: '#FFA436'}} value={"#FFA436"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-orange-70" style={{background: '#CC3D00'}} value={"#CC3D00"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-red-70" style={{background: '#C50042'}} value={"#C50042"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-pink-70" style={{background: '#C60084'}} value={"#C60084"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-purple-70" style={{background: '#722291'}} value={"#722291"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-violet-70" style={{background: '#592ACB'}} value={"#592ACB"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-blue-80" style={{background: '#073072'}} value={"#073072"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-green-80" style={{background: '#005E5E'}} value={"#005E5E"} onClick={e => this.onColor1(e, "value")}/>
            </div>
            <div>
              <Color className="color-black" style={{background: '#000000'}} value={"#000000"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-off-black" style={{background: '#20123A'}} value={"#20123A"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-gray-90" style={{background: '#202340'}} value={"#202340"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-gray-80" style={{background: '#42425A'}} value={"#42425A"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-gray-70" style={{background: '#5E5E72'}} value={"#5E5E72"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-gray-60" style={{background: '#7A7A8B'}} value={"#7A7A8B"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-gray-50" style={{background: '#9595A3'}} value={"#9595A3"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-gray-40" style={{background: '#B1B1BC'}} value={"#B1B1BC"} onClick={e => this.onColor1(e, "value")}/>
            </div>
            <div>
              <Color className="color-gray-30" style={{background: '#CDCDD4'}} value={"#CDCDD4"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-gray-20" style={{background: '#EDEDF0'}} value={"#EDEDF0"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-gray-10" style={{background: '#F9F9FA'}} value={"#F9F9FA"} onClick={e => this.onColor1(e, "value")}/>
              <Color className="color-white" style={{background: '#FFFFFF'}} value={"#FFFFFF"} onClick={e => this.onColor1(e, "value")}/>
            </div>
          </PaletteContainer>
        </ContainerRight>
        <Caption style={{paddingTop: '2rem'}}><Icon src={require('../../../../icons/touch-red.gif')} alt="icon"/>Hey, you can try this!</Caption>
      </div>
    );
  }
}

export default Contrast;



// WEBPACK FOOTER //
// src/assets/Mozilla/DesignTokens/Contrast/Contrast.js